import { useStyle } from "@/components/organisms/supervisor/style";
import { Filter20Regular } from "@fluentui/react-icons";
import { PopoverView } from "@/components/atoms/popover";
import { Button } from "@fluentui/react-components";
import { useInteractionStyle } from "@/components/organisms/interaction/style";
import { FilterButtonProps } from "./types";

export const FilterButton = (props: FilterButtonProps) => {
	const { filterNumber, content } = props;
	const classes = useStyle();
	const interactionClasses = useInteractionStyle();

	return (
		<div>
			<PopoverView
				classes={{ content: classes.settingsPopover }}
				positioning={{
					position: "below",
					align: "end",
				}}
				trigger={
					filterNumber > 0 ? (
						<Button
							shape="circular"
							onClick={(e) => {
								e.preventDefault();
							}}
							className={interactionClasses.filterButton}
						>
							<div className={interactionClasses.filterFontWeight}>
								{filterNumber}
							</div>
							<Filter20Regular
								className={interactionClasses.filterButtonIcon}
							/>
						</Button>
					) : (
						<Button
							appearance="transparent"
							icon={<Filter20Regular />}
							onClick={(e) => {
								e.preventDefault();
							}}
							className={classes.filterTrigger}
						/>
					)
				}
				content={content}
			/>
		</div>
	);
};
